/**
 * Merken in de catalogus. Levert het CRM een `merk`-veld, dan is dat leidend;
 * anders leiden we het merk af uit het artikelnummer (FR… = Frankly, NB… = NextBrush).
 */
export const MERKEN = [
  { id: "frankly", naam: "Frankly", prefixen: ["FR"] },
  { id: "nextbrush", naam: "NextBrush", prefixen: ["NB", "NEXTBRUSH"] },
];

const opNaam = (waarde) => {
  const schoon = String(waarde || "").trim().toLowerCase();
  if (!schoon) return null;
  return MERKEN.find((m) => m.id === schoon || m.naam.toLowerCase() === schoon) || null;
};

/** Merk van dit product, of null als het onbekend is. */
export function productBrand(product) {
  const uitCrm = opNaam(product?.merk ?? product?.brand);
  if (uitCrm) return uitCrm;
  const sku = String(product?.sku || "").trim().toUpperCase();
  if (!sku) return null;
  return MERKEN.find((m) => m.prefixen.some((p) => sku.startsWith(p))) || null;
}

/** Merken die in deze lijst voorkomen, met het aantal producten per merk. */
export function brandCounts(producten) {
  const tellers = new Map();
  (producten || []).forEach((p) => {
    const merk = productBrand(p);
    if (!merk) return;
    tellers.set(merk.id, (tellers.get(merk.id) || 0) + 1);
  });
  return MERKEN.filter((m) => tellers.has(m.id)).map((m) => ({ ...m, aantal: tellers.get(m.id) }));
}
